<!--礼物列表-->
<template>
    <div class="gift">
        <img src="../../../assets/images/common/gift.png" alt="">
        <div class="gift-list">
            <img v-for="(item,index) in list" :key="index"
                 :src="`/api/resource/resource/resource/download/${item.photo}?imgStyleName=no_watermark_compress`"
                 alt="">
        </div>
        <div class="desc">
            {{total}} 人赠送礼物
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // 赠送人列表
            list: [Array],
            // 赠送总数
            total: {
                default: 0,
            },
        }
    }
</script>

<style scoped>
    .gift {
        background: #f9f9f9;
        border-radius: 20px;
        height: 2.3rem;
        position: relative;
        display: flex;
    }

    .gift img {
        height: 2.3rem;
        margin-right: 0.2rem;
    }

    .gift .gift-list {
        flex: 1;
        overflow: hidden;
    }

    .gift .gift-list img {
        height: 1.9rem;
        width: 1.9rem;
        border-radius: 2rem;
        display: inline-block;
        margin: 0.2rem;
    }

    .gift .desc {
        margin-right: 10px;
        line-height: 2.3rem;
        font-size: 12px;
        color: #6a6c6e;
    }
</style>